import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
    templateUrl: './errorpage.component.html',
    styleUrls: ['./errorpage.component.scss'],
    standalone: false
})

export class ErrorPageComponent {
  currentDate: Date
  constructor(
    private router: Router,
    private titleService: Title
  ) {
    this.currentDate = new Date();
    this.titleService.setTitle('Oops Error');
  }

  url = this.router.url;
  mobileUser = this.url.includes('mobile-errorpage') ? true : false; 

  gotoHome() {
    this.router.navigateByUrl('/');
  }

  getAccessibleTimeLabel(): string {
    const date = this.currentDate;
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    
    const dayName = days[date.getDay()];
    const monthName = months[date.getMonth()];
    const dayNum = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const year = date.getFullYear();
    
    // Format time with year as whole number
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const hour12 = hours % 12 || 12;
    
    return `${dayName} ${monthName} ${dayNum} ${hour12}:${minutes}:${seconds} ${ampm} ${year}`;
  }

}
